// src/components/Navbar.js
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../App.css";

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [open, setOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  return (
    <nav className={`navbar ${isRTL ? "rtl" : "ltr"}`}>
      {/* Logo */}
      <Link to="/" className="logo-link" onClick={() => setOpen(false)}>
        <img
          src="/images/dearteacher-logo.png"
          alt="Logo"
          className="nav-logo"
        />
        <span>#MyDearTeacher</span>
      </Link>

      {/* Hamburger */}
      <button
        className="hamburger"
        aria-label="toggle menu"
        onClick={() => setOpen(!open)}
      >
        <div className={`bar ${open ? "open" : ""}`}></div>
        <div className={`bar ${open ? "open" : ""}`}></div>
        <div className={`bar ${open ? "open" : ""}`}></div>
      </button>

      {/* Links */}
      <ul className={`nav-links ${open ? "active" : ""}`}>
        <li>
          <NavLink to="/" end onClick={() => setOpen(false)}>
            {t("navHome")}
          </NavLink>
        </li>
        {/* Removed Mission link and replaced with About */}
        <li>
          <NavLink to="/about" onClick={() => setOpen(false)}>
            {t("navAbout")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/founder" onClick={() => setOpen(false)}>
            {t("navFounder")}
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/student-space"
            onClick={() => setOpen(false)}
          >
            {t("navStudentSpace")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/books" onClick={() => setOpen(false)}>
            {t("navBooks")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/blog" onClick={() => setOpen(false)}>
            {t("navBlog")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/join" onClick={() => setOpen(false)}>
            {t("navJoin")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/contact" onClick={() => setOpen(false)}>
            {t("navContact")}
          </NavLink>
        </li>
        <li>
          <NavLink to="/events" onClick={() => setOpen(false)}>
            {t("navEvents")}
          </NavLink>
        </li>

        {/* Language switcher */}
        <li className="lang-switch">
          <button onClick={() => changeLanguage("en")}>EN</button>
          <span>|</span>
          <button onClick={() => changeLanguage("ar")}>ع</button>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
